import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import { axiosClient, queryClient } from "../../clients";

import type { IMemberLaboratories } from "./routeType";

import type { IPickMutation } from "@/api";
import { getApi } from "@api/apiPath";
import { useGetAllMemberLaboratories } from "@/api/members/laboratories/getAll";
import { useGetMemberLaboratory } from "@/api/members/laboratories/get";

const { getPath } = getApi("members.laboratories.put");

type IExtractedRouteType = IMemberLaboratories["laboratorySingleUpdate"];

export type IPutMemberLaboratory = IPickMutation<IExtractedRouteType>;

const putMemberLaboratory: MutationFunction<
  IPutMemberLaboratory["response"],
  IPutMemberLaboratory["variables"]
> = ({ labId, ...data }) => {
  return axiosClient.put(getPath({ labId }), data);
};

export const usePutMemberLaboratory = createMutation({
  mutationFn: putMemberLaboratory,
  onSuccess: (_, { labId }) => {
    queryClient.invalidateQueries({
      queryKey: useGetAllMemberLaboratories.getKey(),
    });
    queryClient.invalidateQueries({
      queryKey: useGetMemberLaboratory.getKey({ labId }),
    });
  },
});
